<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("Municipality Report Summary") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-3 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-3 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected="onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-xl-2 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  voucherValue && voucherValue.length > 0 ? 'shift-up' : ''
                "
                >{{ $t("Select") }} {{ $tc("Type", 1) }}</label
              >
              <multiselect
                :options="voucherArray"
                v-model="voucherValue"
                :searchable="true"
                placeholder="Select Tyoe"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getMunicipalityReportSummary('N', 'N')"
            >
              {{ $t("fetch") }}
              <!-- {{ $t("report") }} -->
            </button>
          </div>
          <!-- <div class="col-lg-8 col-xl-2 align-self-center mb-3">
            <div class="input_material">
              <b-form-input
                type="search"
                @input="onSearch"
                v-model="searchText"
                placeholder="Search Bill No"
              ></b-form-input>
            </div>
          </div> -->

          <div
            v-if="municipalityRecords.length > 0"
            class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- s -->

            <a
              target="_blank"
              @click="getMunicipalityReportSummary('Y', 'N')"
              title="Download as Excel"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
            <a
              target="_blank"
              @click="getMunicipalityReportSummary('N', 'Y')"
              title="Download as Pdf"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/pdf-icon.svg"
                height="25"
                width="25"
              />
            </a>
          </div>
        </div>
      </div>
      <div
        style="overflow-x:scroll;width: auto !important"
        ref="exportable_table"
      >
        <table class="swc-report-table" border="1">
          <thead class="bg-lightgrey font-weight-bold">
            <th>Show Date</th>
            <th>Cinema Name</th>
            <th>Screen</th>
            <th>Ticket Type</th>
            <th>Pay Type</th>
            <th>Average Ticket Price</th>
            <th>Admits</th>
            <th>Comps</th>
            <!-- <th>Gross Amount</th>
            <th>Offers</th> -->
            <th>Gross Amount</th>
            <!-- <th>VAT%</th> -->
            <th>VAT Amount</th>
            <th>Net Amount</th>
            <!-- <th>M-Tax%</th> -->
            <th>M-Tax Amount</th>
          </thead>
          <tbody v-if="municipalityRecords.length > 0">
            <template
              v-for="(municipalityObj,
              municipalityIndex) in municipalityRecords"
            >
              <tr :key="municipalityIndex">
                <td :rowspan="municipalityObj.showDateRowspan + 1">
                  {{ municipalityObj.t_show_date }}
                </td>
                <td :rowspan="municipalityObj.showDateRowspan + 1">
                  {{ municipalityObj.cinema_name }}
                </td>
              </tr>
              <template
                v-for="(showDateObj,
                showDateIndex) in municipalityObj.showDateData"
              >
                <tr :key="showDateIndex + 'ShowDate'">
                  <td :rowspan="showDateObj.screenDataRowspan + 1">
                    {{ showDateObj.screen_name }}
                  </td>
                </tr>
                <template
                  v-for="(screenData, screenIndex) in showDateObj.screenData"
                >
                  <tr :key="screenIndex + 'screenData'">
                    <td :rowspan="screenData.paymentDataRowspan + 1">
                      {{ screenData.ticket_type_name }}
                    </td>
                  </tr>
                  <template
                    v-for="(paymentObj, paymentIndex) in screenData.paymentData"
                  >
                    <tr :key="paymentIndex + 'PaymentData'">
                      <td class="text-left">{{ paymentObj.payment_mode }}</td>
                      <td class="text-right">
                        {{ currFormat(paymentObj.class_rate) }}
                      </td>
                      <td class="text-right">{{ paymentObj.admits }}</td>
                      <td class="text-right">
                        {{ paymentObj.m_vat_free_ticket || 0 }}
                      </td>
                      <!-- <td class="text-right">
                        {{ currFormat(paymentObj.gross_amount) }}
                      </td>
                      <td class="text-right">
                        {{ currFormat(paymentObj.offers) }}
                      </td> -->
                      <td class="text-right">
                        {{ currFormat(paymentObj.bo_amount) }}
                      </td>
                      <!-- <td class="text-right">{{
                        currFormat(paymentObj.vat_percentage)
                      }}</td> -->
                      <td class="text-right">
                        {{ currFormat(paymentObj.vat) }}
                      </td>
                      <td class="text-right">
                        {{ currFormat(paymentObj.before_m_tax) }}
                      </td>
                      <!-- <td class="text-right">{{
                        currFormat(paymentObj.m_tax_percentage)
                      }}</td> -->
                      <td class="text-right">
                        {{ currFormat(paymentObj.m_tax) }}
                      </td>
                    </tr>
                  </template>
                  <tr
                    :key="screenIndex + 'screenTotal'"
                    class="font-weight-bold movie_bg"
                  >
                    <td class="text-left" colspan="3">Total</td>
                    <td class="text-right">
                      {{
                        screenData.paymentData.reduce((acc, { admits }) => {
                          return acc + +parseFloat(admits);
                        }, 0)
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        screenData.paymentData.reduce(
                          (acc, { m_vat_free_ticket }) => {
                            return acc + +parseFloat(m_vat_free_ticket || 0);
                          },
                          0
                        )
                      }}
                    </td>
                    <!-- <td class="text-right">
                      {{
                        currFormat(
                          screenData.paymentData.reduce(
                            (acc, { gross_amount }) => {
                              return acc + +parseFloat(gross_amount);
                            },
                            0
                          )
                        )
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        currFormat(
                          screenData.paymentData.reduce((acc, { offers }) => {
                            return acc + +parseFloat(offers);
                          }, 0)
                        )
                      }}
                    </td> -->
                    <td class="text-right">
                      {{
                        currFormat(
                          screenData.paymentData.reduce(
                            (acc, { bo_amount }) => {
                              return acc + +parseFloat(bo_amount);
                            },
                            0
                          )
                        )
                      }}
                    </td>
                    <!-- <td class="text-right">{{
                      currFormat(
                        screenData.paymentData.reduce(
                          (acc, { vat_percentage }) => {
                            return acc + +parseFloat(vat_percentage);
                          },
                          0
                        )
                      )
                    }}</td> -->
                    <td class="text-right">
                      {{
                        currFormat(
                          screenData.paymentData.reduce((acc, { vat }) => {
                            return acc + +parseFloat(vat);
                          }, 0)
                        )
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        currFormat(
                          screenData.paymentData.reduce(
                            (acc, { before_m_tax }) => {
                              return acc + +parseFloat(before_m_tax);
                            },
                            0
                          )
                        )
                      }}
                    </td>
                    <!-- <td class="text-right">{{
                      currFormat(
                        screenData.paymentData.reduce(
                          (acc, { m_tax_percentage }) => {
                            return acc + +parseFloat(m_tax_percentage);
                          },
                          0
                        )
                      )
                    }}</td> -->
                    <td class="text-right">
                      {{
                        currFormat(
                          screenData.paymentData.reduce((acc, { m_tax }) => {
                            return acc + +parseFloat(m_tax);
                          }, 0)
                        )
                      }}
                    </td>
                  </tr>
                </template>
              </template>
            </template>
            <tr class="bg-lightgrey font-weight-bold">
              <td colspan="6" class="text-left">Grand Total</td>
              <td class="text-right">
                {{ currFormat(grandTotal.ticketsSold_total) }}
              </td>
              <td class="text-right">
                {{ currFormat(grandTotal.m_vat_free_ticket) }}
              </td>
              <!-- <td class="text-right">
                {{ currFormat(grandTotal.gross_amount_total) }}
              </td>
              <td class="text-right">
                {{ currFormat(grandTotal.offers_total) }}
              </td> -->
              <td class="text-right">
                {{ currFormat(grandTotal.bo_amount_total) }}
              </td>
              <!-- <td class="text-right"></td> -->
              <td class="text-right">{{ currFormat(grandTotal.vat_total) }}</td>
              <td class="text-right">
                {{ currFormat(grandTotal.before_m_tax_total) }}
              </td>
              <!-- <td class="text-right"></td> -->
              <td class="text-right">
                {{ currFormat(grandTotal.m_tax_total) }}
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="20">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService-v2";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import { authenticationService } from "@/services/AuthenticationService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";

export default {
  components: {
    NoRecords,
    VueHtml2pdf
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: ""
      },
      fromDate: new Date(),
      toDate: new Date(),
      distributorsList: [],
      movieTotal: [],
      selectedDistributor: {
        d_company_name: "",
        d_id: ""
      },
      selectedMovie: {
        movie_title: "",
        movie_id: ""
      },
      MovieList: [],
      municipalityRecords: [],
      excelFilePath: "",
      nepalMonth: {},
      grandTotal: {},
      disabledDates: {
        from: ""
      },
      searchText: "",
      voucherArray: ["With Voucher", "Without Voucher"],
      voucherValue: "Without Voucher"
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.fromDate = new Date();
    Promise.all([
      this.getCinemaList(),
      this.getDistributorsList()
    ]).then(() => {});
    // if (CinemaObj) {
    //   this.onSelectCinema(CinemaObj);
    // }
  },
  watch: {
    // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
    //   if (CinemaObj) {
    //     this.onSelectCinema(CinemaObj);
    //   }
    // },
    excelFilePath(value) {
      this.excelFilePath = value;
    },
    fromDate: function(value) {
      this.disabledDates.from = new Date(
        moment(this.fromDate).format("YYYY"),
        parseFloat(moment(this.fromDate).format("MM")),
        1
      );
      this.toDate = moment(this.toDate).isAfter(value, "months")
        ? moment(this.fromDate)
            .endOf("month")
            .format("YYYY-MM-DD")
        : this.toDate;
    }
  },
  mounted() {},
  methods: {
    onChangeDate: function(e, type){
      if(type == 'from'){
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
    moment,
    getCinemaList: function() {
      MasterService.GetCinemasByRoles()
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function(event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    getDistributorsList: function() {
      let body = {
        tableName: "ms_distributors",
        d_is_active: "Y"
      };
      MasterService.GetActiveList(body)
        .then(response => {
          const { data } = response;

          if (data && data.status && data.Records.length > 0) {
            this.distributorsList = data.Records;
          } else {
            this.$toasted.show("Failed to fetch distributor names");
          }
        })
        .catch(error =>
          Vue.toasted.show(
            "Catch Error on MasterStore fetchDistributorsList",
            error
          )
        );
    },
    fetchDistributorMovies() {
      if (!this.dropDown.selectedCinemaId) {
        this.$toasted.show("Please Select Cinema");
        this.selectedDistributor = [];
        this.$forceUpdate();
      } else {
        this.MovieList = [];
        this.selectedMovie.movie_id = "";
        this.selectedMovie.movie_title = "";
        let payload = {
          fromDate: this.fromDate,
          toDate: this.toDate,
          cinema_id: this.dropDown.selectedCinemaId,
          cinema_name: this.dropDown.selectedCinemaName,
          d_id: this.selectedDistributor.d_id,
          d_company_name: this.selectedDistributor.d_company_name,
          country_id: authenticationService.get("BRGLOPCO"),
          filter_with_key: "ss_actual_start_date",
          isVoucherShow: this.voucherValue == "With Voucher" ? "Y" : "N"
        };
        ReportsService.getDistributorMovieFormatV2(payload)
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records) {
              this.MovieList = data.Records;
            } else
              this.$toasted.show(data.message || "Opps! Something went wrong");
          })
          .catch(error => {
            this.$toasted.show(
              "Catch Error on ReportStore fetchDistributorMovies",
              error
            );
          });
      }
    },
    getMunicipalityReportSummary(isExcel, isPdf) {
      if (isExcel == "N" || isPdf == "N") {
        this.municipalityRecords = [];
      }
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader = this.$loading.show();
      let payload = {
        user_name: this.secureStore.get("USINFO").username,
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.cine_address || "",
        d_name: this.selectedDistributor.d_company_name,
        d_id: this.selectedDistributor.d_id,
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        movie_id: this.selectedMovie.movie_id,
        isExcel,
        isPdf,
        isVoucherShow: this.voucherValue == "With Voucher" ? "Y" : "N"
      };
      ReportsService.getMunicipalityReportSummary(payload)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.municipalityRecords = [...data.Records];
            this.grandTotal = { ...data.grandTotal };
            // this.movieTotal = [...data.movieTotal];
            if (isExcel == "Y" && data.excelPath) {
              window.open(data.excelPath, "_blank");
            }
            if (isPdf == "Y" && data.pdfPath) {
              window.open(data.pdfPath, "_blank");
            }
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
          loader.hide();
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    }
  }
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  border: 1px solid black;
}
.swc-report-table td {
  white-space: nowrap;
}
.swc-report-table th {
  white-space: nowrap !important;
  border: 1px solid black !important;
}
.swc_table_header th {
  border: 1px solid black !important;
}
.no_border {
  border: 0px !important;
}
.movie_bg {
  background-color: #eaeaea;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/municipalityReportSummary.vue